<script setup>
import {computed} from 'vue'
import Button from "@/common/Button.vue"
import {useAppStore} from '@/stores/appStore'
import {useToastsStore} from '@/stores/toasts'

const appStore = useAppStore()
const toastsStore = useToastsStore()

const betaMode = computed(() => appStore.betaMode)
const alphaMode = computed(() => appStore.alphaMode)

const addToast = () => {
    toastsStore.add({
        title: 'Duis aute irure',
        body: 'Lorem ipsum dolor sit amet.'
    })
}

const addToastNoTitle = () => {
    toastsStore.add({
        body: 'Lorem ipsum dolor sit amet.'
    })
}

const addToastWarning = () => {
    toastsStore.add({
        body: 'This has auto hide disabled.',
        colourScheme: 'warning',
        disableAutoHide: true
    })
}

const addToastDanger = () => {
    toastsStore.add({
        body: 'This has auto hide disabled.',
        colourScheme: 'danger',
        disableAutoHide: true
    })
}
</script>

<template>
    <div class="card mb-3">
        <div class="card-header">
            Introduction
        </div>

        <div class="card-body">
            <p class="lead">Welcome to CreativeCMS</p>
            <div class="row">
                <div class="col-sm-6"></div>
                <div class="col-sm-6"></div>
            </div>
        </div>

        <div v-if="betaMode">
            <Button @click="addToast">
                Toast
            </Button>

            <Button @click="addToastNoTitle">
                Simple toast
            </Button>

            <Button @click="addToastWarning">
                Warning
            </Button>

            <Button @click="addToastDanger">
                Danger
            </Button>
        </div>

        <span v-if="alphaMode">
            </span>
    </div>
</template>